export default "__VITE_ASSET__B8Ox0Hhr__"